import ngSanitize from '@splunk/olly-angular-sanitize';
import { filtersToSuggestions } from '../../../common/ui/charts/DrilldownControlGroup';

import showdown from 'showdown';
window.showdown = showdown;
import showdownPrettify from 'showdown-prettify/dist/showdown-prettify.js';
showdown.extensions.prettify = showdownPrettify;
import showdownTable from 'showdown-table';
showdown.extensions.table = showdownTable;
import showdownGithub from 'showdown-github/dist/showdown-github.js';
showdown.extensions.github = showdownGithub;

// eslint-disable-next-line inclusive-language/use-inclusive-words
// adapted from https://github.com/btford/angular-markdown-directive/blob/master/markdown.js
angular
    .module('signalview.markdown', [ngSanitize])
    .provider('markdownConverter', function () {
        // custom extension for Showdown to prevent tab nabbing
        const addRelLinkAttribute = {
            type: 'output',
            regex: /(<a .+<\/a>)/g,
            replace: (match) => {
                return match.replace('>', ' rel="noopener noreferrer">');
            },
        };
        showdown.extension('addRelLinkAttribute', addRelLinkAttribute);

        const replaceDashboardVariables = {
            type: 'output',
            filter: function (text, converter, options) {
                if (options.replaceVariables) {
                    return options.replaceVariables(text);
                }
                return text;
            },
        };
        showdown.extension('replaceDashboardVariables', replaceDashboardVariables);

        let opts = {};
        return {
            config: function (newOpts) {
                opts = newOpts;
            },
            $get: function () {
                return new showdown.Converter(opts);
            },
        };
    })
    .config([
        'markdownConverterProvider',
        function (markdownConverterProvider) {
            // options to be passed to Showdown
            // see: https://github.com/coreyti/showdown#extensions
            markdownConverterProvider.config({
                // prettify supports <pre></pre> to prettify indentation and border
                // github supports ~~strike through this text~~
                // we can add custom extensions here later, such as <sfx>plotnumber</sfx> to
                // add single value chart text
                extensions: [
                    'prettify',
                    'github',
                    'addRelLinkAttribute',
                    'replaceDashboardVariables',
                ],
                literalMidWordUnderscores: true,
                literalMidWordAsterisks: true,
                strikethrough: true,
            });
        },
    ])
    .directive('btfMarkdown', [
        '$sanitize',
        'markdownConverter',
        'dashboardUtil',
        'urlOverridesService',
        function ($sanitize, markdownConverter, dashboardUtil, urlOverridesService) {
            const makeAndSetReplaceVariablesOption = (filters) => {
                const replaceVariables = (text) =>
                    dashboardUtil.resolveUrlWithVariables(text, filtersToSuggestions(filters));
                markdownConverter.setOption('replaceVariables', replaceVariables);
            };

            return {
                restrict: 'AE',
                link: function (scope, element, attrs) {
                    if (attrs.btfMarkdown) {
                        let filters;

                        if (scope?.dashboard && scope?.drilldownSuggestions?.length) {
                            // ironically, dashboard is in scope only for single chart, not for dashboard chart
                            const { variables } = scope.dashboard?.filters;
                            filters = {
                                time: urlOverridesService.getGlobalTimePicker(),
                                variables,
                            };
                        } else if (scope.$ctrl?.filterAlias) {
                            filters = {
                                time: urlOverridesService.getGlobalTimePicker(),
                                variables: scope.$ctrl?.filterAlias || [],
                            };
                        }

                        if (filters) {
                            makeAndSetReplaceVariablesOption(filters);
                        }

                        scope.$on('dashboard.updateOverrides', function (event, data) {
                            const updatedVariables = (filters?.variables || [])
                                .filter(
                                    (variable) =>
                                        !data.variables.find(
                                            (variableOverride) =>
                                                variableOverride.property === variable.property
                                        )
                                )
                                .concat(data.variables);

                            makeAndSetReplaceVariablesOption({
                                variables: updatedVariables,
                                time: urlOverridesService.getGlobalTimePicker(),
                            });

                            const currentMarkdownText =
                                scope.$ctrl?.chartModel?.sf_uiModel?.markdownText;

                            if (currentMarkdownText) {
                                // markdownConverter will not update markdown automatically, we need to re-convert it
                                const html = markdownConverter.makeHtml(currentMarkdownText);
                                element.html(html);
                            }
                        });

                        scope.$watch(attrs.btfMarkdown, function (newVal) {
                            markdownConverter.setOption('tables', !attrs.disabledTables);
                            const html = newVal
                                ? $sanitize(markdownConverter.makeHtml(newVal))
                                : '';
                            element.html(html);
                        });
                    } else {
                        const html = $sanitize(markdownConverter.makeHtml(element.text()));
                        element.html(html);
                    }
                },
            };
        },
    ]);
